export const CREATE_TIMELINE_SCHEDULE_REQUEST = 'CREATE_TIMELINE_SCHEDULE_REQUEST';
export const CREATE_TIMELINE_SCHEDULE_SUCCESS = 'CREATE_TIMELINE_SCHEDULE_SUCCESS';
export const CREATE_TIMELINE_SCHEDULE_FAILURE = 'CREATE_TIMELINE_SCHEDULE_FAILURE';
export const CREATE_TIMELINE_SCHEDULE_RESET = 'CREATE_TIMELINE_SCHEDULE_RESET';


export const FETCH_TIMELINE_SCHEDULE_REQUEST = "FETCH_TIMELINE_SCHEDULE_REQUEST"
export const FETCH_TIMELINE_SCHEDULE_SUCCESS = "FETCH_TIMELINE_SCHEDULE_SUCCESS"
export const FETCH_TIMELINE_SCHEDULE_FAILURE = "FETCH_TIMELINE_SCHEDULE_FAILURE"